import { initializeApp } from 'firebase/app';
import { getFunctions } from 'firebase/functions';

// Firebase web config is public; env vars override defaults for other projects/environments.
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? 'AIzaSyCXAHP-NQHN6KhflMhVZ2Ifm6f59GzriCs',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? 'scottdev.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? 'scottdev',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? 'scottdev.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '702123770477',
  appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '1:702123770477:web:6a8bdc4a99321c41043564',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Functions
export const functions = getFunctions(app);

export default app; 